export function addHTMLLineBreak(text: string) {
  const newText = text.replace(/\r?\n/g, '<br />');
  return newText;
}
